import { ApiClient } from '@center-technologies/shared-api-clients';

export interface GetRelationshipsParams {
  sphereId: string;
  relationshipType?: string;
  direction?: 'incoming' | 'outgoing' | 'both';
  page?: number;
  limit?: number;
}

export interface RelationshipData {
  id: string;
  relationshipType: string;
  sourceId: string;
  targetId: string;
  metadata?: Record<string, any>;
  active: boolean;
  createdAt: string;
  createdBy: string;
  deactivatedAt?: string;
  deactivatedBy?: string;
}

export interface GetRelationshipsResult {
  success: boolean;
  relationships?: RelationshipData[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  error?: string;
}

export async function getRelationships(
  graphClient: ApiClient,
  params: GetRelationshipsParams
): Promise<GetRelationshipsResult> {
  try {
    const queryParams = new URLSearchParams({
      page: (params.page || 1).toString(),
      limit: (params.limit || 50).toString()
    });

    if (params.relationshipType) {
      queryParams.append('relationshipType', params.relationshipType);
    }

    if (params.direction) {
      queryParams.append('direction', params.direction);
    }

    const response = await graphClient.get(`/relationships/${params.sphereId}?${queryParams.toString()}`);
    
    // The API returns the relationships array directly, not wrapped in an object
    const relationships = Array.isArray(response) ? response : (response?.relationships || []);
    
    return {
      success: true,
      relationships: relationships,
      pagination: response?.pagination
    };
  } catch (error: any) {
    console.error('Failed to get relationships:', error);
    return {
      success: false,
      error: error?.message || 'Failed to get relationships'
    };
  }
}